import { PlayIcon } from "lucide-react";
import React from "react";
import type { PreviewProps } from "../types";

export function VideoPreview({ postable }: PreviewProps) {
  // Simple placeholder for video
  const thumbnailUrl =
    postable.postable.thumbnailUrl || "https://placehold.co/600x400/png";
  const title = postable.postable.title || "Video";

  return (
    <div className="relative rounded-lg overflow-hidden w-full aspect-video shadow-sm">
      <div
        className="w-full h-full bg-cover bg-center"
        style={{ backgroundImage: `url(${thumbnailUrl})` }}
      />

      {/* Play button overlay */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="bg-black/30 rounded-full p-2">
          <PlayIcon className="h-8 w-8 text-white" />
        </div>
      </div>

      {/* Title overlay */}
      <div className="absolute bottom-0 left-0 right-0 bg-black/50 p-2">
        <div className="text-white font-semibold text-center">{title}</div>
      </div>
    </div>
  );
}
